
  import { SquareButton } from '@/ui/components/Button';
  import { defineComponent } from 'vue';
  import { Modal } from '@/ui/components/Modal';

  export default defineComponent({
    components: { SquareButton, Modal },
    props: {
      active: {
        type: Boolean,
        required: true,
      },
    },
    setup() {
      return {
        csEmail: process.env.VUE_APP_CS_EMAIL,
      };
    },
  });
